/**
 * Created by lihanying on 2017/10/18.
 */
import React from 'react'
import { parseTime } from '../../../util/index'

export default class extends React.Component {
  render() {
    const { record, tbDetail } = this.props
    let currentTime = new Date()
    let startTime = parseTime(record.start_time)
    let tableSlice
    if (tbDetail.data.player && tbDetail.data.player.length > 2) {
      tableSlice = tbDetail.data.player.slice(0, 2)
    } else {
      tableSlice = tbDetail.data.player
    }
    return (
      <div style={{ marginBottom: '2rem' }}>
        {startTime ? (
          <div>
            <div className="containerBox">
              <p className="titleHead">
                已开始:{Math.round((currentTime - startTime) / 60000)}分钟
              </p>
              <div className="contentBody">
                {tableSlice &&
                  tableSlice.map((item, idx) => {
                    return (
                      <div
                        key={idx}
                        className={
                          tbDetail.data.player.length == 1
                            ? 'contentBodyCenter'
                            : 'contentBodyLeft'
                        }
                      >
                        <img
                          src={item.avatar}
                          alt=""
                          className="contentBodyImg"
                        />
                      </div>
                    )
                  })}
              </div>
              <div className="contentBody" style={{ marginBottom: '1rem' }}>
                {tbDetail.data.player &&
                  tbDetail.data.player.map((item, idx) => {
                    return (
                      <div key={idx} className="footBox">
                        <img src={item.avatar} alt="" className="footImg" />
                      </div>
                    )
                  })}
              </div>
            </div>
            <div
              style={{
                height: '300px',
                overflowY: 'scroll',
                overflowX: 'hidden',
              }}
            >
              <div className="listItem">
                <div style={{ fontSize: '28px' }}>球台账单</div>
                <div style={{ fontSize: '28px' }}>
                  ¥
                  {(() => {
                    let priceSum = 0
                    tbDetail.data.bill_list &&
                      tbDetail.data.bill_list.map((item) => {
                        priceSum += +item.price
                      })
                    return priceSum
                  })()}
                </div>
              </div>
              {tbDetail.data.bill_list &&
                tbDetail.data.bill_list.map((item, idx) => {
                  return (
                    <div key={idx} className="listBox">
                      <div className="listItem">
                        <div style={{ fontSize: '28px' }}>
                          {item.commodity_name}
                        </div>
                        <div style={{ fontSize: '28px' }}>¥{item.price}</div>
                      </div>
                      <div className="listItem">
                        <div style={{ fontSize: '16px' }}>
                          {item.time_range}
                        </div>
                      </div>
                      <div className="listItem">
                        <div style={{ fontSize: '16px' }}>{item.nickname}</div>
                        <div style={{ fontSize: '20px' }}>{item.uprice}</div>
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        ) : (
          <div className="condition">空闲</div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTableStatus/component/status.js